import type { MaybeRefOrGetter } from 'vue';

export function useFloatLabel(
  value: MaybeRefOrGetter<string | number | boolean> = ref(''),
  enabled: MaybeRefOrGetter<boolean> = ref(true),
) {
  const focused = ref(false);

  const classes = computed(() => {
    if (!toValue(enabled)) {
      return null;
    }

    const valueAsValue = toValue(value);

    return {
      floatlabel: true,
      focused: unref(focused),
      empty: !valueAsValue,
      populated: !!valueAsValue,
    };
  });

  const handleFocus = () => {
    focused.value = true;
  };

  const handleBlur = () => {
    focused.value = false;
  };

  return reactive({
    handleFocus,
    handleBlur,
    classes,
    focused,
  });
}
